import { Table } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { TAGS_HEADER } from '@app/constants/tables';
import { AddTagsModal } from '@app/pages/Tags/components';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import type { NTables } from '@app/types';
import { getPaginationItemRenderWithDataTestIds } from '@app/utils';

import { useTags } from '@pages/Tags/hooks/useTags';
import { useTagsEffects } from '@pages/Tags/hooks/useTagsEffects';

import { adaptDataToTable } from '@pages/Tags/utils/adaptDataToTable';

import type { FC } from 'react';

import '@pages/Tags/styles/Tags.scss';

export const Tags: FC = () => {
  const {
    tags,
    handleEdit,
    isLoading,
    isModalOpen,
    handleCancel,
    selectedIcon,
    form,
    setSelectedIcon,
    submitMainForm,
    currentTagId,
    hasUserRightToEditTags,
    isMobile,
    handleChange,
    pageNumber,
    rowsPerPage,
    isCurrentTagDeleted,
    IsOn,
    getTagsHandler,
    setHeader,
    setIsModalOpen,
  } = useTags();

  useTagsEffects({ getTagsHandler, setHeader, setIsModalOpen });

  if (!IsOn) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="Tags">
      <Table<NTables.TagsHeader>
        columns={TAGS_HEADER}
        dataSource={adaptDataToTable(tags, handleEdit, hasUserRightToEditTags)}
        className="Tags__table"
        rowKey="key"
        loading={isLoading}
        rowClassName={(row) => `tag-item${row.isDeleted ? ' deleted-tag' : ''}`}
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 500 }}
        pagination={{
          itemRender: getPaginationItemRenderWithDataTestIds,
          size: isMobile ? 'small' : 'default',
          showSizeChanger: true,
          showLessItems: isMobile,
          position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
          showTotal: (total, range) =>
            generateSpanWithDataTestId(
              isMobile
                ? `Всего ${total}`
                : `Показаны ${range[0]}-${range[1]} из ${total}`,
              'pagination-info'
            ),
          pageSize: rowsPerPage,
          current: pageNumber,
          onChange: handleChange,
        }}
      />
      <AddTagsModal
        currentTagId={currentTagId}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        form={form}
        submitMainForm={submitMainForm}
        setSelectedIcon={setSelectedIcon}
        selectedIcon={selectedIcon}
        isCurrentTagDeleted={isCurrentTagDeleted}
      />
    </div>
  );
};
